import React, { useContext, useMemo } from "react";
import FormulaGenerator from "../../../FormulaGenerator";
import "./index.scss";
import { getStepInfo } from "../../stepInfo";
import { StepContext } from "../../StepContext";
import { useTranslation } from "../../../i18n";

const EsteticSelectRestorations = ({
  stepId,
  toggleNextBtnState
}) => {
  const {
    language
  } = useTranslation();
  const {
    setStepFormula,
    dentalData
  } = useContext(StepContext);

  function setData(data) {
    setStepFormula(stepId, data);
    toggleNextBtnState(false);
  }

  const formulaHelperText = useMemo(() => {
    return getStepInfo(language, stepId)?.formulaHelperText || "";
  }, [language, stepId]);
  return /*#__PURE__*/React.createElement("div", {
    className: "esteticSelectRestorations"
  }, /*#__PURE__*/React.createElement(FormulaGenerator, {
    projectData: dentalData,
    setProjectDentalData: setData,
    initialSelection: "esteticSelectRestorations",
    availableSwitchers: ["top", "bottom", "base", "fixedProstheses"],
    formulaHelperText: formulaHelperText
  }));
};

export default EsteticSelectRestorations;